import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWeightTrainingNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15.493 8.075L14.2 9.368a1.167 1.167 0 01-1.65 0l-1.767-1.767-3.057 3.057 1.767 1.767a1.167 1.167 0 010 1.65L8.2 15.368a1.167 1.167 0 01-1.65 0l-.602-.602-.894.894a1.167 1.167 0 01-1.65 0L.34 12.596a1.167 1.167 0 010-1.65l.894-.894-.602-.602a1.167 1.167 0 010-1.65l1.293-1.293a1.167 1.167 0 011.65 0l1.767 1.767 3.057-3.057L6.632 3.45a1.167 1.167 0 010-1.65L7.925.507a1.167 1.167 0 011.65 0l.602.602.77-.77a1.167 1.167 0 011.649 0l3.064 3.065a1.167 1.167 0 010 1.65l-.77.77.603.601a1.167 1.167 0 010 1.65zm-6.21-1.974L6.226 9.158l.616.616 3.057-3.057zm5.15 1.15l-1.428-1.428L14.6 4.23 11.77 1.4l-.71.71 1.857 1.856-.884.884-1.856-1.857-.001.002L8.75 1.568 7.693 2.625l5.682 5.682zm-7.058 7.056l1.057-1.057L2.75 7.568 1.693 8.625l1.427 1.427-.002.001 1.857 1.856-.884.884-1.856-1.856-.835.834L4.23 14.6l1.719-1.72z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWeightTrainingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWeightTrainingNormalXsmall;
